module.exports = vueMoment;